import { SCREENS, ACTIONS } from 'a/pictureThis/data/constants';

const initState = {
  screen: SCREENS.PROGRESS,
};

const view = (state = initState, { type, payload }) => {
  switch (type) {
    // change screen according to action payload
    case ACTIONS.CHANGE_SCREEN:
      return {
        screen: payload,
      };
    default:
      return state;
  }
};

export default view;

export const getScreen = state => state.screen;
